import { type ResolvedContextData } from '@common/defaults/ContextData';
import { BrandedHeading, type Props as BrandedHeadingProps } from '@web/atoms/BrandedHeading';
import { HeadingColor } from '@web/atoms/Heading';

import { getWidgetThemeConfig } from '../Widget.config';

type WidgetTitleHeadingProps = Omit<BrandedHeadingProps, 'as'>;

export interface Props extends WidgetTitleHeadingProps {
    contextData: ResolvedContextData;
}

export const WidgetTitle = ({
    contextData,
    icon,
    variant,
    color,
    children,
    accentColor,
    hideBorderBottomUnderline,
    ...rest
}: Props) => {
    const themeConfig = getWidgetThemeConfig(contextData);
    const resolvedHeadingVariant = variant ?? themeConfig.brandedHeadingVariant;
    const resolvedAccentColor = accentColor ?? themeConfig.brandedHeadingAccentColor;
    const shouldHideBorderBottomUnderline =
        themeConfig.hideBorderBottomUnderline || hideBorderBottomUnderline;

    return (
        <BrandedHeading
            as="h2"
            accentColor={resolvedAccentColor}
            color={color || HeadingColor.SIDEBAR}
            hideBorderBottomUnderline={shouldHideBorderBottomUnderline}
            icon={icon || themeConfig.brandedHeadingIcon}
            variant={resolvedHeadingVariant}
            {...rest}
        >
            {children}
        </BrandedHeading>
    );
};
